<template>
  <div v-if="window.width < 1024 ? true : false">
    <div id="navMobile" class="fixed z-10 w-full h-[70px] shadow-xl">
      <div class="w-full h-full relative flex justify-center bg-primary">
        <button
          class="absolute top-1/2 left-0 -translate-y-1/2 text-3xl font-semibold ml-6 text-white transition-all"
          @click="showLeave"
        >
          {{ btnValue }}
        </button>
        <div class="flex justify-center items-center">
          <router-link
            class="w-1/2 cursor-pointer flex justify-center"
            to="/home"
          >
            <inline-svg
              src="/images/logo-quantic-white.svg"
              style=""
              class="w-full h-auto"
              aria-label="Klaus Market logo"
            ></inline-svg
          ></router-link>
        </div>
        <button
          class="absolute top-1/2 right-0 -translate-y-1/2 px-0 mr-6 flex items-center text-white"
          @click="logOut"
        >
          <inline-svg
            src="/images/icons/sign-out-alt-solid.svg"
            width="20px"
            aria-label="Sign out"
            class=""
          ></inline-svg>
        </button>
      </div>
    </div>
    <transition name="slide"
      ><div
        v-if="menuMobile.toggle"
        id="nav"
        class="flex left-0 flex-col py-6 px-4 absolute h-[calc(100%-70px)] z-[9]"
      >
        <acordeon
          :active="acordeon.index == index ? true : false"
          v-for="(item, index) in menu"
          :key="'menu-item-' + index"
        >
          <template v-slot:header>
            <div
              :class="`flex items-center justify-start mr-2 text-white mb-2 ml-6 cursor-pointer  pr-3  ${
                acordeon.index == index ? 'border-b-2 border-b-white ' : ''
              }`"
              @click="actionIndex(index)"
            >
              <inline-svg
                :src="`/images/icons/${item.icon}.svg`"
                fill="white"
                aria-label="Shop"
                class="w-auto"
                style="height: 18px; max-width: 18px"
              />
              <span class="font-semibold ml-3 text-xl select-none">
                {{ item.name }}
              </span>
              <inline-svg
                :src="`/images/icons/angle-${
                  acordeon.index == index ? 'up' : 'down'
                }-solid.svg`"
                fill="white"
                aria-label="Shop"
                class="w-auto ml-2"
                style="height: 18px; max-width: 18px"
              />
            </div>
          </template>
          <template v-slot:body>
            <ul class="menu text-left ml-12 mb-3 text-white">
              <router-link
                v-for="(subItem, index) in item.subMenu"
                :key="`'${item.name}-item-' + ${index}`"
                v-slot="{ href, /* navigate, */ isActive, isExactActive }"
                custom
                :exact="subItem.to == '/' ? true : false"
                :to="subItem.to"
              >
                <li
                  :class="[
                    isActive && 'router-link-active',
                    isExactActive && 'router-link-exact-active'
                  ]"
                >
                  <a
                    class="flex items-center justify-center relative"
                    :href="href"
                    @click="
                      (e) => {
                        e.preventDefault()
                        goToLink(subItem.to)
                      }
                    "
                  >
                    {{ subItem.label }}
                  </a>
                </li>
              </router-link>
            </ul>
          </template>
        </acordeon>
      </div></transition
    >
  </div>
  <div v-else>
    <div id="nav" class="flex left-0 flex-col py-12 px-4 relative h-full z-[1]">
      <router-link class="cursor-pointer p-6 flex items-center" to="/home">
        <inline-svg
          src="/images/logo-quantic-white.svg"
          width="90%"
          style=""
          class="mr-auto"
          aria-label="Klaus Market logo"
        ></inline-svg>
      </router-link>

      <acordeon
        :active="acordeon.index == index ? true : false"
        v-for="(item, index) in menu"
        :key="'menu-item-' + index"
      >
        <template v-slot:header>
          <div
            :class="`flex items-center justify-start mr-2 text-white mb-2 ml-6 cursor-pointer  pr-3 w-fit  ${
              acordeon.index == index ? 'border-b-2 border-b-white ' : ''
            }`"
            @click="actionIndex(index)"
          >
            <inline-svg
              :src="`/images/icons/${item.icon}.svg`"
              fill="white"
              aria-label="Shop"
              class="w-auto"
              style="height: 18px; max-width: 18px"
            />
            <span class="font-semibold ml-3 text-xl select-none">
              {{ item.name }}
            </span>
            <inline-svg
              :src="`/images/icons/angle-${
                acordeon.index == index ? 'up' : 'down'
              }-solid.svg`"
              fill="white"
              aria-label="Shop"
              class="w-auto ml-2"
              style="height: 18px; max-width: 18px"
            />
          </div>
        </template>
        <template v-slot:body>
          <ul class="menu text-left ml-12 mb-3 text-white">
            <router-link
              v-for="(subItem, subIndex) in item.subMenu"
              :key="`'${item.name}-item-${subIndex}'`"
              v-slot="{ href, navigate, isActive, isExactActive }"
              custom
              :exact="subItem.to == '/' ? true : false"
              :to="subItem.to"
            >
              <li
                :class="[
                  isActive && 'router-link-active',
                  isExactActive && 'router-link-exact-active'
                ]"
              >
                <a
                  class="flex items-center justify-center relative"
                  :href="href"
                  @click="navigate"
                >
                  {{ subItem.label }}
                </a>
              </li>
            </router-link>
          </ul>
        </template>
      </acordeon>

      <div class="mt-auto text-left mx-2 text-white">
        <locale-selector
          class="w-100"
          v-if="site && site.locales && site.locales.length > 1"
          :key="
            site && site.locales ? site.locales.length > 1 : 'locale-desocupado'
          "
        />
        <div
          class="bg-white rounded-md h-[1px] w-[100%] mx-auto my-3 opacity-100"
        ></div>
        <div class="flex flex-col items-start">
          <span class="text-white">
            {{ this.user.username }}
          </span>
          <p class="text-white text-wrap">
            {{ this.user.email }}
          </p>
        </div>
        <div
          class="bg-white rounded-md h-[1px] w-[100%] mx-auto my-3 opacity-100"
        ></div>
        <button class="px-0 pt-3 flex items-center" @click="logOut">
          <inline-svg
            src="/images/icons/sign-out-alt-solid.svg"
            width="18px"
            aria-label="Sign out"
            class="mr-2"
          ></inline-svg>
          <span> Sign out </span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex"
import Acordeon from "./Painter/Utils/Acordeon.vue"
import LocaleSelector from "./LocaleSelector.vue"
const storesToResetOnLogout = [
  "product_collections",
  "components",
  "coupons",
  "customers",
  "sites",
  "email_templates",
  "forms",
  "general",
  "media",
  "menus",
  "backlinks",
  "orders",
  "packagings",
  "pages",
  //"popups",
  "products",
  // "signup",
  "styles",
  "translations",
  "validations",
  "product_variants"
]

export default {
  data() {
    return {
      show: false,
      windowWidth: window.innerWidth,
      menu: [
        {
          name: "Shop",
          icon: "store-solid",
          subMenu: [
            {
              label: "Orders",
              to: "/orders"
            },
            {
              label: "Customers",
              to: "/customers"
            },
            {
              label: "Coupons",
              to: "/coupons"
            },
            {
              label: "Packaging",
              to: "/packagings"
            }
          ]
        },
        {
          name: "Products",
          icon: "box-open-solid",
          subMenu: [
            {
              label: "Products",
              to: "/products"
            },
            {
              label: "Categories",
              to: "/product_collections"
            }
          ]
        },
        {
          name: "Content",
          icon: "copy-solid",
          subMenu: [
            {
              label: "Pages",
              to: "/pages"
            },
            {
              label: "Media",
              to: "/media"
            },
            {
              label: "Popups",
              to: "/popups"
            },
            {
              label: "Menus",
              to: "/menus"
            },
            {
              label: "Forms",
              to: "/forms"
            },
            {
              label: "Emails",
              to: "/email_templates"
            }
          ]
        },
        {
          name: "Configuration",
          icon: "cog-solid",
          subMenu: [
            {
              label: "Backlinks",
              to: "/backlinks"
            },
            {
              label: "Translations",
              to: "/translations"
            },
            {
              label: "Components",
              to: "/components"
            },
            {
              label: "Styles",
              to: "/styles"
            },
            {
              label: "Zones",
              to: "/zones"
            },
            {
              label: "Settings",
              to: "/sites"
            }
          ]
        }
      ]
    }
  },
  computed: {
    ...mapGetters(["user"]),
    ...mapGetters(["site"]),
    ...mapGetters(["acordeon"]),
    ...mapGetters(["menuMobile"]),
    ...mapGetters(["window"]),

    btnValue: function () {
      if (this.menuMobile.toggle) {
        return "✕"
      }
      return "☰"
    }
  },
  components: {
    Acordeon,
    LocaleSelector
  },
  methods: {
    ...mapActions(["LOG_OUT"]),
    ...mapActions(["UPDATE_general"]),
    async logOut() {
      await this.LOG_OUT()
      await this.$router.push("/")
      storesToResetOnLogout.map((current) => {
        return this.$store.dispatch(`CLEAN_STORE_${current}`)
      })
    },
    showLeave() {
      //console.log("Me ejecuté")
      this.UPDATE_general({
        param: "menuMobile",
        key: "toggle",
        value: !this.menuMobile.toggle
      })
      this.acordeon.index = undefined
    },

    onResize() {
      this.UPDATE_general({
        param: "window",
        key: "width",
        value: window.innerWidth
      })
    },

    actionIndex(index) {
      if (this.acordeon.index == index) {
        /* this.UPDATE_general({
          param: "acordeon",
          key: "active",
          value: false
        }) */
        this.acordeon.index = undefined
      } else {
        this.acordeon.index = index
      }
    },

    hideDropdown() {
      this.acordeon.index = undefined
    },
    goToLink(link) {
      //console.log("CHECKING", link)
      this.$router.push(link)
      this.showLeave()
    }
  },
  async mounted() {
    this.$nextTick(() => {
      window.addEventListener("resize", this.onResize)
    })
  }
}
</script>

<style lang="scss" scoped>
#nav {
  bottom: 0;
  width: 16rem;

  background-color: $quanticDark;
}
.menu {
  list-style: none;
  padding: 0 0 !important;
  li {
    transition: all 0.3s ease;

    font-weight: 600;
    border-bottom: 1.5px solid transparent;
    width: fit-content;
    * {
      font-weight: 600;
    }
  }
  li:hover,
  li.router-link-active,
  li.router-link-exact-active {
    border-bottom: 1.5px solid white;
    cursor: pointer;
  }
  a {
    color: white;
    font-size: 1rem;
  }
  button {
    color: white;
  }
}
</style>
